import { SxProps } from '@mui/system'

import { theme } from 'src/providers/ThemeProvider'

type AvisosLexnetStylesType = {
  cell: SxProps
  cellImportancia: (importancia: string) => SxProps
  cellParada: (parada: boolean) => SxProps
  btnDocument: SxProps
  document: SxProps
  documentIcon: SxProps
}

export const avisosLexnetStyles: AvisosLexnetStylesType = {
  cell: {
    maxWidth: 92,
    padding: theme.spacing(0.5, 2),
    borderRadius: '4px',
    color: theme.colors.gray14,
    fontFamily: theme.corporate.secondaryFont,
    fontSize: 12,
    fontWeight: 400,
    lineHeight: '16px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    textTransform: 'capitalize'
  },

  cellImportancia: (importancia: string) => {
    let backgroundColor: string

    switch (importancia) {
      case 'critico':
        backgroundColor = theme.corporate.warningCritical
        break
      case 'importante':
        backgroundColor = theme.corporate.warningHigh
        break
      default:
        backgroundColor = theme.corporate.warningInfo
    }

    return {
      ...avisosLexnetStyles.cell,
      backgroundColor,
      flex: '1 1 auto',
      maxWidth: '110px',

      '& span': {
        overflow: 'hidden',
        textOverflow: 'ellipsis'
      }
    }
  },

  cellParada: (parada: boolean) => ({
    ...avisosLexnetStyles.cell,
    background: parada ? theme.corporate.infoTrue : theme.corporate.infoFalse
  }),

  btnDocument: {
    margin: 0,
    padding: theme.spacing(0.25, 0.5),
    height: 'unset'
  },

  document: {
    color: theme.colors.byzantineBlue200,
    fontFamily: theme.corporate.secondaryFont,
    fontSize: 12,
    fontWeight: 400,
    lineHeight: '16px',
    textTransform: 'capitalize',
    paddingLeft: theme.spacing(0.5),
    margin: 0,
    textAlign: 'left'
  },

  documentIcon: {
    fontSize: 16
  }
}
